// removed by extract-text-webpack-plugin
module.exports = {"tagCloud":"antd-pro-charts-tag-cloud-tagCloud"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/Charts/TagCloud/index.less
// module id = 1329
// module chunks = 0